/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ThemeInputs */

const en_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theme`)
};

const es_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const fr_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thème`)
};

const de_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design`)
};

const ja_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テーマ`)
};

const zh_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主题`)
};

const ar_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المظهر`)
};

const id_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const it_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const ru_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тема`)
};

const pt_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const ko_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`테마`)
};

/**
* | output |
* | --- |
* | "Theme" |
*
* @param {ThemeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const theme = /** @type {((inputs?: ThemeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ThemeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_theme(inputs)
	if (locale === "es") return es_theme(inputs)
	if (locale === "fr") return fr_theme(inputs)
	if (locale === "de") return de_theme(inputs)
	if (locale === "ja") return ja_theme(inputs)
	if (locale === "zh") return zh_theme(inputs)
	if (locale === "ar") return ar_theme(inputs)
	if (locale === "id") return id_theme(inputs)
	if (locale === "it") return it_theme(inputs)
	if (locale === "ru") return ru_theme(inputs)
	if (locale === "pt") return pt_theme(inputs)
	return ko_theme(inputs)
});